import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { ICONS, unit } from '@hcr/ui'

import { ButtonBuyAccommodation } from '../button-buy-accommodation'
import { Drawer } from '../drawer'

interface OwnerBuyAccommodationDrawerProps {
  isOpen: boolean
  onClose: () => void
}

export const OwnerBuyAccommodationDrawer: FC<OwnerBuyAccommodationDrawerProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation()

  return (
    <Drawer open={isOpen} onClose={onClose} anchor='bottom'>
      <Stack maxHeight='65vh'>
        <IconButton onClick={onClose} aria-label={t('home.close')} sx={{ alignSelf: 'end' }}>
          <FontAwesomeIcon icon={ICONS.farXmark} />
        </IconButton>
        <Stack paddingBottom={unit(5)}>
          <Typography variant='headlineS' marginBottom={unit(3)}>
            {t('home.owner-buy-accommodation.title')}
          </Typography>
          <Typography variant='bodyM'>{t('home.owner-buy-accommodation.description')}</Typography>
        </Stack>

        <ButtonBuyAccommodation isDrawerOpen={true} variant='contained' color='primary'>
          {t('home.owner-buy-accommodation.cta')}
        </ButtonBuyAccommodation>
      </Stack>
    </Drawer>
  )
}
